import React from "react";
import FadeInAnimation from "../Common/FadeInAnimation";
import { BiCodeAlt, BiCloud, BiStar, BiTrendingUp, BiShield, BiBrain, BiRocket, BiUserCheck } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const StartseiteFeatures = () => {
  const { t } = useTranslations();
  return (
    <section className="ptb-100" style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Dekorative Hintergrund-Elemente */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '150px',
        height: '150px',
        background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.08), rgba(76, 175, 80, 0.08))',
        borderRadius: '50%',
        filter: 'blur(30px)',
        zIndex: '1'
      }}></div>

      <div style={{
        position: 'absolute',
        bottom: '20%',
        right: '10%',
        width: '200px',
        height: '200px',
        background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.06), rgba(76, 175, 80, 0.06))',
        borderRadius: '50%',
        filter: 'blur(40px)',
        zIndex: '1'
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: '2' }}>
        <div className="section-title text-center mb-5">
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
            color: 'white',
            padding: '12px 30px',
            borderRadius: '30px',
            fontSize: '14px',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginBottom: '25px',
            boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
          }}>
            {t('startseite_features_title')}
          </div>
          <h2 style={{
            fontSize: '2.8rem',
            fontWeight: '700',
            background: 'linear-gradient(135deg, #080a3c, #1a1c4a)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '25px',
            lineHeight: '1.2'
          }}>
            {t('startseite_features_description')}
          </h2>
          <p style={{
            fontSize: '1.1rem',
            color: '#333',
            lineHeight: '1.7',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            {t('startseite_features_description2')}
          </p>
        </div>

        <FadeInAnimation direction="up" delay={200}>
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiCodeAlt style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_transformation')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_transformation_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiCloud style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_it_loesungen_fuer_kmus')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_it_loesungen_fuer_kmus_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiStar style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_digital_strategie')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_digital_strategie_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiTrendingUp style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_wachstum_skalierung')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_wachstum_skalierung_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiShield style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_sicherheit_compliance')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_sicherheit_compliance_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiBrain style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_ki_automatisierung')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_ki_automatisierung_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiRocket style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_schnelle_umsetzung')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_schnelle_umsetzung_description')}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-4">
              <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '25px',
                border: '1px solid rgba(89, 189, 101, 0.1)',
                height: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                }}>
                  <BiUserCheck style={{ fontSize: '28px', color: 'white' }} />
                </div>
                <h3 style={{
                  color: '#080a3c',
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {t('startseite_features_kundenzentriert')}
                </h3>
                <p style={{
                  color: '#333',
                  fontSize: '0.9rem',
                  lineHeight: '1.6',
                  margin: '0'
                }}>
                  {t('startseite_features_kundenzentriert_description')}
                </p>
              </div>
            </div>
          </div>
        </FadeInAnimation>
      </div>

      <style jsx>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 2.2rem !important;
          }
          
          .col-lg-3 {
            margin-bottom: 20px !important;
          }
        }
            .col-lg-3:hover > div {
                    transform: translateY(-5px);
                    box-shadow: 0 20px 50px rgba(89, 189, 101, 0.15) !important;
                }
                
                a:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3) !important;
                }
      `}</style>
    </section>
  );
};

export default StartseiteFeatures;
